import React from 'react';
import { ChevronRightIcon, ChevronDownIcon } from 'lucide-react';
import { faqItems } from './data';
import { useDarkMode } from '../../context/DarkModeContext';
interface FAQsTabProps {
  expandedFaq: number | null;
  setExpandedFaq: React.Dispatch<React.SetStateAction<number | null>>;
}
export const FAQsTab: React.FC<FAQsTabProps> = ({
  expandedFaq,
  setExpandedFaq
}) => {
  const {
    darkMode
  } = useDarkMode();
  return <div data-id="element-7432" data-mp="4l6vd5t7kf08">
      <h2 className={`text-2xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-7433" data-mp="4lygfmp6iuc9">
        Frequently Asked Questions
      </h2>
      <div className="space-y-4" data-id="element-7434" data-mp="3qzgilblejgzf">
        {faqItems.map((faq, index) => <div key={index} className={`border rounded-lg overflow-hidden shadow-sm ${darkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'}`} data-id="element-7435" data-mp="3m0wvv8yzi160" data-mpi={index}>
            <div className={`p-4 flex justify-between items-center cursor-pointer transition-colors ${expandedFaq === index ? darkMode ? 'bg-purple-900/30' : 'bg-indigo-50' : darkMode ? 'bg-gray-800 hover:bg-gray-750' : 'bg-white hover:bg-gray-50'}`} onClick={() => setExpandedFaq(expandedFaq === index ? null : index)} data-id="element-7436" data-mp="3h3mx32ppgd5i">
              <h4 className={`font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-7437" data-mp="pjnjz5pkxjwg">
                {faq.question}
              </h4>
              {expandedFaq === index ? <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 ${darkMode ? 'text-purple-400' : 'text-indigo-600'}`} data-id="element-7438" data-mp="1n98vm15hs9ml" /> : <ChevronRightIcon className={`h-5 w-5 flex-shrink-0 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-7439" data-mp="19bk6gh4e6gbq" />}
            </div>
            {expandedFaq === index && <div className={`p-4 border-t ${darkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'}`} data-id="element-7440" data-mp="1vnxwj37qho7">
                <p className={darkMode ? 'text-gray-300' : 'text-gray-600'} data-id="element-7441" data-mp="24ht8n1i48ks5">
                  {faq.answer}
                </p>
              </div>}
          </div>)}
      </div>
    </div>;
};